import React from "react";
import Header from "./components/header/header";
import NavBar from "./components/navBar/navBar";
import Footer from "./components/footer/footer";
import Services from "./components/servicesList/services";
import FAQ from "./components/‌faq/faq";
import PageTitle from "./components/pageTitle/pageTitle";

const WhatWeDoPage = () => {
  return (
    <div>
      <Header />
      <NavBar />
      <PageTitle
        title={"What we do"}
        breadcrumbSteps={["Home", "What we do"]}
      />
      <Services />
      <FAQ />
      <Footer />
    </div>
  );
};

export default WhatWeDoPage;
